import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Layout, ErrorNotice } from '../components/Layout';
import { api } from '../lib/api';

export function PrivacyPage() {
  const [confirmation, setConfirmation] = useState('');
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const deletion = useMutation({
    mutationFn: () => api('/api/privacy/delete-account', { method: 'DELETE' }),
    onSuccess: () => { queryClient.clear(); navigate('/login?deleted=1'); },
  });
  return (
    <Layout title="ความเป็นส่วนตัว">
      <section className="mx-auto max-w-2xl space-y-5">
        <article className="card space-y-3 leading-relaxed text-slate-700">
          <h2 className="text-lg font-bold text-slate-900">ประกาศความเป็นส่วนตัวฉบับย่อ</h2>
          <p>ระบบเก็บข้อมูลบัญชี รายการ ผล OCR และไฟล์เอกสารที่คุณอัปโหลดเพื่อให้บริการสร้างกิจกรรมปฏิทิน ข้อมูลถาวรอยู่ใน Cloudflare D1 และ private R2 เท่านั้น</p>
          <p>ภาพหรือภาพหน้าแรกของ PDF อาจถูกส่งไปยังผู้ให้บริการ OCR ที่ตั้งค่าไว้เพื่อประมวลผล ไฟล์ต้นฉบับไม่มี public access และระบบไม่เก็บ access token ใน browser storage</p>
          <p>คุณดู แก้ไข และลบใบนัดได้ตลอดเวลา ค่า retention เริ่มต้น 365 วันและผู้ดูแลระบบสามารถกำหนดให้สั้นลงได้</p>
          <p>หากต้องการขอสำเนาข้อมูลหรือแจ้งเหตุความปลอดภัย ให้ติดต่อช่องทางใน README/SECURITY.md ของ deployment ที่ใช้งาน</p>
        </article>
        <article className="rounded-2xl border border-red-200 bg-red-50 p-5">
          <h2 className="font-bold text-red-900">ลบบัญชีและข้อมูลทั้งหมด</h2>
          <p className="mt-2 text-sm text-red-800">จะลบไฟล์เอกสารจาก R2, ข้อมูลรายการ, OCR, session และ token จาก D1 การทำรายการนี้ย้อนกลับไม่ได้ กิจกรรมที่สร้างไว้ใน Google Calendar อาจต้องลบก่อนจากหน้ารายละเอียด</p>
          <label className="mt-4 block"><span className="label text-red-900">พิมพ์ “ลบข้อมูล” เพื่อยืนยัน</span><input className="field border-red-300" value={confirmation} onChange={(e) => setConfirmation(e.target.value)} /></label>
          <button className="mt-4 min-h-12 w-full rounded-xl bg-red-700 px-4 font-semibold text-white disabled:opacity-50" disabled={confirmation !== 'ลบข้อมูล' || deletion.isPending} onClick={() => deletion.mutate()}>{deletion.isPending ? 'กำลังลบ…' : 'ลบบัญชีและข้อมูลทั้งหมด'}</button>
        </article>
        {deletion.error && <ErrorNotice message={deletion.error.message} />}
      </section>
    </Layout>
  );
}
